import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { CODEARTIFACT_PACKAGE_ANNOTATION } from './api';

/** Card in the entity page of every component with the `ssm.io/codeartifact-package` annotation. */
const versionsCard = EntityCardBlueprint.make({
  name: 'versions',
  params: {
    filter: entity => Boolean(entity.metadata.annotations?.[CODEARTIFACT_PACKAGE_ANNOTATION]),
    type: 'content',
    loader: () => import('./VersionsCard').then(m => <m.VersionsCard />),
  },
});

export const codeArtifactPlugin = createFrontendPlugin({
  pluginId: 'codeartifact',
  extensions: [versionsCard],
});
